import { render } from "./SearchEmail.vue?vue&type=template&id=87c3e0d0&scoped=true"
import script from "./SearchEmail.vue?vue&type=script&lang=js"
export * from "./SearchEmail.vue?vue&type=script&lang=js"

import "./SearchEmail.vue?vue&type=style&index=0&id=87c3e0d0&scoped=true&lang=css"
import "./SearchEmail.vue?vue&type=style&index=1&id=87c3e0d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c3e0d0"]])

export default __exports__